var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmiscanlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "46.207px",
    height: "46.207px",
    viewBox: "0 0 46.207px 46.207",
    enableBackground: "new 0 0 200.987 46.207",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F11B8A",
    d: "M22.994,46.204c0.034,0,0.073,0.003,0.107,0.003c5.954,0,11.379-2.256,15.475-5.955l0.472-27.534 L22.994,46.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F11B8A",
    d: "M23.103,0C10.341,0,0,10.345,0,23.104c0,10.975,7.651,20.15,17.906,22.509L38.999,6.349 C34.854,2.418,29.264,0,23.103,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F11B8A",
    d: "M46.208,23.104c0-5.037-1.618-9.697-4.357-13.495v26.993C44.59,32.804,46.208,28.145,46.208,23.104"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmiscanlogo);
export default __webpack_public_path__ + "static/media/amiscanlogo.bded359ae8ac713fcf1289345215a0fd.svg";
export { ForwardRef as ReactComponent };